var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"two-line":"","dense":""}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.titulo))]),_c('v-list-item-subtitle',{attrs:{"title":_vm.conTitle ? _vm.subtitulo : ''}},[_vm._v(" "+_vm._s(_vm.subtitulo)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }